import React from "react";
import { useTranslation } from "../i18n";

// Portrait GIFs are cropped to at most 4:5 so a tall one can't dominate the
// card; landscape ones keep their own shape.
const MIN_ASPECT = 4 / 5;
const FALLBACK_ASPECT = 16 / 9;

/**
 * A recognition's GIF in the feed: a centered, fixed-width tile that keeps
 * the GIF's proportions (reserving the space before it loads, so the card
 * doesn't jump) with the GIPHY credit as a small badge. `gif` is the `gif`
 * object on a recognition response ({ id, url, width, height, title }).
 */
const RecognitionGif = ({ gif, className = "" }) => {
  const { t } = useTranslation("common");
  if (!gif?.url) return null;
  const aspect =
    gif.width > 0 && gif.height > 0
      ? Math.max(gif.width / gif.height, MIN_ASPECT)
      : FALLBACK_ASPECT;
  return (
    <figure className={`self-center mx-auto w-full max-w-sm ${className}`}>
      <div
        className="relative w-full overflow-hidden rounded-2xl bg-gray-100 ring-1 ring-black/5 shadow-sm"
        style={{ aspectRatio: aspect }}
      >
        <img
          src={gif.url}
          alt={gif.title || t("gif.alt")}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <span className="absolute bottom-2 right-2 rounded-md bg-black/55 px-1.5 py-0.5 text-[10px] font-medium leading-none text-white/90 pointer-events-none">
          {t("gif.via_giphy")}
        </span>
      </div>
    </figure>
  );
};

export default RecognitionGif;
